/* eslint-disable */
// https://stackoverflow.com/a/2117523

export default function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/lib/uuid.js